import { Component, OnInit } from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {ButtonEditorModel} from '@shared/components/multiple-button-editor/multiple-button-editor.component';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Subject} from 'rxjs';
import {DownloadType} from "../../Fields";

@Component({
    standalone: false,
    selector: 'particle-filing-download-or-attachment-to-task',
  templateUrl: './filing-download-or-attachment-to-task.component.html',
  styleUrls: ['./filing-download-or-attachment-to-task.component.scss']
})
export class FilingDownloadOrAttachmentToTaskComponent implements OnInit {
  data: DialogModel;
  selectedExportOptions: any;
  unSubscribe$ = new Subject<void>();
  downloadOrAttachButtonList: ButtonEditorModel[] = [];
  filingExportOptions: any;
  hasSingleCase = false;
  singleCaseButtonDescription = 'Download form as an [TYPE] file where you can review and share with others via email.';
  hasMergedItem = false
  XmlMergeCountrySupport: string;
  constructor() { }

  ngOnInit() {
    this.filingExportOptions = this.getFilingExportOptions(this.data.input['options']);
    /*if (this.data.input['selectedItemCount'] === 1) {
      this.hasSingleCase = true;
      this.selectedExportOptions = this.filingExportOptions.ExportOptions.find(option => option.DownloadType === 'XML');
    } else {
      this.selectedExportOptions = this.filingExportOptions.ExportOptions.find(option => option.DownloadType === this.filingExportOptions.DefaultDownloadType);
    }
    this.downloadOrAttachButtonList = [
      this.getSetSelectedDownloadButton(),
      this.getAttachmentButtonDetails(),
    ];*/

    this.filingExportOptions = this.getFilingExportOptions(this.data.input['options']);
    if(this.filingExportOptions.XmlMergeCountrySupport){
      this.XmlMergeCountrySupport = this.filingExportOptions.XmlMergeCountrySupport.join(', ');
    }

    if(this.data.input['selectedItemCount'] === 1){
      this.hasSingleCase = true;
    }
    this.selectedExportOptions = this.getExportDownloadOption();
    this.singleCaseButtonDescription = this.singleCaseButtonDescription.replace('[TYPE]', this.selectedExportOptions.DownloadType);
    this.downloadOrAttachButtonList = [
      this.getSetSelectedDownloadButton(),
      this.getAttachmentButtonDetails(),
    ];
  }

  onOkClicked(): boolean {
    return true;
  }
  onDownloadOrAttach(event) {
    this.data.input['ExportOption'] = this.selectedExportOptions;
    this.data.input['clickAction'].emit(event);
  }

  getSetSelectedDownloadButton() {
    return {
      id: this.selectedExportOptions.DownloadType,
      title: 'Download Form(s)',
      description: this.hasSingleCase ? this.singleCaseButtonDescription : this.selectedExportOptions.MetaData['Description'],
      buttonTitle: this.selectedExportOptions.MetaData['ButtonTitle'],
      imageSource: this.selectedExportOptions.MetaData['ImageSource'],
      isDisabled: false
    };
  }
  ngOnDestroy(): void {

  }
  getAttachmentButtonDetails() {
    //will remove scenarioType condition once GMT-Forms will move to GMT
    if (this.data.input['scenarioType']){
      return {
        id: `AttachtoTask-${this.selectedExportOptions.DownloadType}`,
        title: 'Attach to Task',
        description: 'Attach this form to a Task and share with Stakeholders including a checklist on next steps.',
        buttonTitle: 'Attach to Task',
        imageSource: 'https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/save-to-my-repo.png',
        isDisabled: true
      };
    } else {
      if (this.hasSingleCase) {
        return {
          id: `AttachtoTask-${this.selectedExportOptions.DownloadType}`,
          title: 'Attach to Task',
          description: 'Attach this form to a Task and share with Stakeholders including a checklist on next steps.',
          buttonTitle: 'Attach to Task',
          imageSource: 'https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/save-to-my-repo.png',
          isDisabled: false
        };
      } else {
        return {
          id: `AttachtoTask-${this.selectedExportOptions.DownloadType}`,
          title: 'Attach to Task',
          description: 'Attach form to a Task and share with Stakeholders including a checklist on next steps.',
          buttonTitle: 'Attach to Task',
          imageSource: 'https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/save-to-my-repo.png',
          isDisabled: false
        };
      }
    }
  }
  private getFilingExportOptions(exportOptions: any) {
    let clonedItems = JSON.parse(JSON.stringify(exportOptions));
    if(this.data.input['selectedItemCount'] > 1){
      clonedItems.ExportOptions = clonedItems.ExportOptions.filter(item=>item.MetaData['IsMultipleCase']);
      clonedItems.ExportOptions.forEach(item=>{
        if(item.IsMerge){
          this.hasMergedItem = true;
          item.MetaData['Title'] = item.MetaData['Title'].replace('Type', `Merged ${item.DownloadType}`);
        }else{
          item.MetaData['Title'] = item.MetaData['Title'].replace('Type', `${item.DownloadType}`);
        }
      });
      clonedItems.ExportOptions.forEach(item=>{
        if(item.DownloadType !== DownloadType.XML && item.DownloadType !== DownloadType.fvie){
          item.MetaData['ButtonTitle'] = 'Download (.ZIP)';
        }
      });
    }
    else{
      clonedItems.ExportOptions.forEach(item=>{
        item.MetaData['Title'] = item.MetaData['Title'].replace('Type', `${item.DownloadType}`);
      });
      clonedItems.ExportOptions = clonedItems.ExportOptions.filter(item=>item.MetaData['IsSingleCase']);
    }

    return clonedItems;
  }

  private getExportDownloadOption() {
    let downloadType = this.filingExportOptions.DefaultDownloadType;
    let selectedExportOption;
    if(this.data.input['selectedItemCount'] > 1){
      let hasMergedItems = false;
      this.filingExportOptions.ExportOptions.forEach(item=>{
        if(item.IsMerge){
          hasMergedItems = true;
        }
      });
      if( hasMergedItems ) downloadType = DownloadType.XML;
      else if( downloadType !== DownloadType.fvie ) downloadType = DownloadType.ZIP;
    }
    else {
      if ( downloadType === DownloadType.ZIP ) downloadType = DownloadType.XML;
    }
    selectedExportOption = this.filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    if(!selectedExportOption){
      downloadType = this.filingExportOptions.DefaultDownloadType;
      selectedExportOption = this.filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    }
    return selectedExportOption;
  }
}
